
import React from "react";
import { Button } from "@/components/ui/button";
import { Trophy } from "lucide-react";

interface SkillsHeaderProps {
  onViewCertificates: () => void;
}

export const SkillsHeader = ({ onViewCertificates }: SkillsHeaderProps) => {
  return (
    <div className="flex justify-between items-center">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Skills Assessment</h1>
        <p className="text-gray-600 mt-2">
          Validate your expertise through comprehensive skill assessments.
          Earn certificates and showcase your professional capabilities.
        </p>
      </div>
      <Button className="bg-emerald-600 hover:bg-emerald-700" onClick={onViewCertificates}>
        <Trophy className="w-4 h-4 mr-2" />
        View Certificates
      </Button>
    </div>
  );
};
